import { jsx } from 'react/jsx-runtime';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/app.js';

function renderInstance(node, props, instance) {
  if (!node.hasAttribute('data-llm')) {
    node.setAttribute('data-llm', '');
    const root = ReactDOM.createRoot(node);
    root.render(jsx(React.StrictMode, {
      children: jsx(App, Object.assign({}, props, {
        instance: instance
      }))
    }));
  }
}
function renderEmbed(node, props) {
  if (!node.hasAttribute('data-llm')) {
    node.setAttribute('data-llm', '');
    const root = ReactDOM.createRoot(node);
    root.render(jsx(React.StrictMode, {
      children: jsx(App, Object.assign({}, props, {
        embedded: true
      }))
    }));
  }
}
function observeIntersections(targetElement, callback) {
  if (targetElement === void 0) {
    targetElement = document;
  }
  if (callback === void 0) {
    callback = target => {};
  }
  let observer;
  if ('IntersectionObserver' in window) {
    const observerOptions = {
      root: targetElement.parentElement ? targetElement.parentElement : targetElement,
      rootMargin: '50px',
      threshold: [0.01, 0.99]
    };
    observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          callback(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
  } else {
    observer = {
      observe: callback,
      disconnect: () => {}
    };
  }
  return observer;
}
function observeMutations(targetElement, callback) {
  if (targetElement === void 0) {
    targetElement = document;
  }
  if (callback === void 0) {
    callback = mutation => {};
  }
  let observer;
  if ('MutationObserver' in window) {
    const config = {
      attributes: false,
      childList: true,
      subtree: true
    };
    observer = new MutationObserver((mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          callback(mutation);
        }
        /*
        else if (mutation.type === 'attributes') {
          console.log(`The ${mutation.attributeName} attribute was modified.`);
        }
        */
      }
    });
    observer.observe(targetElement, config);
  } else {
    observer = {
      disconnect: () => {}
    };
  }
  return observer;
}
function queryElements(elements) {
  const filteredElements = [];
  const iterable = Array.isArray(elements) ? elements : isIterable(elements) ? elements : [elements];
  for (const element of iterable) {
    const childElements = element.querySelectorAll('llm-embed');
    for (const childElement of childElements) {
      if (!childElement.hasAttribute('data-llm')) {
        filteredElements.push(childElement);
      }
    }
    if (element.tagName && element.tagName.toLowerCase() === 'llm-embed' && !element.hasAttribute('data-llm')) {
      filteredElements.push(element);
    }
  }
  return filteredElements;
}
function isIterable(element) {
  return element != null && typeof element[Symbol.iterator] === 'function';
}

export { isIterable, observeIntersections, observeMutations, queryElements, renderEmbed, renderInstance };
//# sourceMappingURL=utils.js.map
